<template>
    <div :class="{Checkout:!this.$store.state.isMobile,mCheckout:this.$store.state.isMobile}">
        <topLogo :is-show-progress="true"></topLogo>
        <div class="progress" ref="progress">
            <div class="item" v-for="(item,i) in progresslist" :key="i" @click="onProgressItemClick(i)">
                <p class="num" :class="i+1>$route.meta.progress?'gray':''">{{i+1}}</p>
                <span :class="i+1>$route.meta.progress?'colorg':''">{{item.toUpperCase()}}</span>
                <p class="line" :class="i+2>$route.meta.progress?'gray':''" v-if="i+1!=progresslist.length"></p>
            </div>
        </div>
        <main>
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
    import topLogo from "../components/topLogo";
    import bottomNav from "../components/bottomNav";

    export default {
        name: "Checkout",
        components: {
            topLogo,
            bottomNav
        },
        data() {
            return {
                progress: this.$store.state.progress,
                progresslist: [
                  this.$store.state.langPage['v4-topmenu']['TXT_panier'],
                  // this.$store.state.langPage['v4-topmenu']['TXT_adressettransport'],
                  // this.$store.state.langPage['compte-commandes-liste']['TXT_moyendepaiement'],
                  this.$store.state.langPage['v4-topmenu']['TXT_confirmation']
                ]
            };
        },
        mounted() {
            console.log(this.$route);
            if (this.$store.state.isMobile) {
                let step = this.$route.meta.progress;
                let scrollWidth = (step-2).mul(500);
                this.$refs['progress'].scrollTo(scrollWidth,0);
            }
        },
        methods: {
            onProgressItemClick(index) {
                //只有不是灰色的按钮时，才可以点击。 index为2时，progress为3
                if (index + 1 < this.$route.meta.progress) {
                    switch (index) {
                        case 0:
                            this.$router.replace({path: '/panier'});
                            break;
                        // case 1:
                        //     this.$router.replace({path: '/checkout/transport'});
                        //     break;
                        // case 2:
                        //     this.$router.replace({path: '/checkout/paiement'});
                        //     break;
                    }
                }
            }
        }
    };
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout.less">
</style>
<style lang="less">
    .Checkout {
        .main {
            background-color: #fff;
            padding: 72px 112px;
            margin-bottom: 50px;
        }

        .SubTitle {
            font-size: 32px;
            font-family: Ogg-Roman;
            line-height: 0.48rem;
            margin-bottom: 0.21rem;
        }

        .opt {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 0.48rem;
            padding-bottom: 1rem;
            font-size: 16px;
            font-family: MaisonNeue-Medium;
            font-weight: bold;

            button {
                min-width: 2rem;
                height: 0.48rem;
                background-color: #000;
                color: #fff;
                font-size: 16px;
                font-family: MaisonNeue-Medium;
                font-weight: bold;
            }
        }
    }

    .mCheckout {
        .main {
            background-color: #fff;
            padding: 7vw;
            margin-bottom: 0.5rem;
        }

        .SubTitle {
            font-size: 28px;
            line-height: 40px;
            font-family: Ogg-Roman;
            margin-bottom: 5vw;
        }

        .opt {
            display: flex;
            justify-content: space-between;
            align-items: center;

            p {
                font-size: 10pt;
            }

            button {
                background-color: #000;
                color: #fff;
                font-size: 10pt;
                padding: 2vw 10vw;
            }
        }
    }
</style>
